'use client';
import type { ReactNode } from 'react';

/**
 * Error component fallback when error occurs.
 *
 * @returns Fallback component
 */
export default function ErrorComponent(): ReactNode {
  return 'Tekniskt fel uppstod, vänligen försök igen senare.';
}
